import React, { Component } from 'react';
import Banner from './banner';
import TextSlider from './textslide';

class App extends Component {
    render() {
        return (
            <>
                <div>
                    <br />
                    <br />
                    <br />
                </div>
                <div>
                    <TextSlider />
                </div>
                <div style={{ marginTop: "7px" }}>
                    <Banner />
                </div>
            </>
        );
    }
}
export default App;
